import React, { Component } from "react";
import classnames from "classnames";

import * as styles from "./NoDataMessage.scss";

export interface INoDataMessageProps {
    className?: string;
    asBanner?: boolean;
    children?: React.ReactNode;
}

export class NoDataMessage extends Component<INoDataMessageProps> {
    public render() {
        const { className, asBanner } = this.props;

        return (
            <div
                className={classnames(
                    styles["no-data-message"],
                    asBanner && styles["as-banner"],
                    className,
                )}
            >
                {this.props.children}
            </div>
        );
    }
}
